import _ from 'lodash';


export default class HelperService {

	findBy = (list, keyGetter, value) => {
		var found = list.find(item => {
			return keyGetter(item) == value;
		});

		// console.log('found', found);
		return found;
	};

	sortBy(list, key) {
		return _.orderBy(list, key);
	}

	groupBy = (list, keyGetter) => {
		const map = new Map();

		list.forEach((item) => {
			const key = keyGetter(item);
			const collection = map.get(key);
			if (!collection) {
				map.set(key, [item]);
			}
			else {
				collection.push(item);
			}
		});

		return map;
	};
}